<template>
    <div>
        <!-- 搜索条件 -->
        <div class="whiteBox" style="display: flex;justify-content: space-between; flex-wrap: wrap;">
            <div style="display: flex;align-items: center;">
                <span>{{ $t('view.项目名称：') }}</span>
                <el-input v-model="form.sectionName" :placeholder="$t('view.请输入招标项目名称以搜索')" style="flex: 1;" size="mini"></el-input>
            </div>
            <div style="display: flex;align-items: center">
                <span>{{ $t('view.招标单位：') }}</span>
                <el-input v-model="form.companyName" :placeholder="$t('view.请输入单位名称名称以搜索')" style="flex: 1;" size="mini"></el-input>
            </div>
            <div style="display: flex;align-items: center;">
                 <span>{{ $t('view.项目状态：') }}</span>
                <el-select size="mini" clearable v-model="form.status"  style="flex: 1; ">
                    <el-option v-for="item in statusList" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
                </el-select>
            </div>
            <div style="display: flex;align-items: center;margin-top: 20px">
                <span>{{ $t('view.提交日期：') }}</span>
                <el-date-picker style="flex:1;" size="mini" value-format="yyyy-MM-dd" v-model="TimeList" clearable type="daterange" range-separator="-" ></el-date-picker>
            </div>
            <div style="display: flex;align-items: center;margin-top: 20px">
                <span>{{ $t('view.提交人：') }}</span>
                <el-input v-model="form.createByName" style="flex:1;margin-left: 10px;" size="mini"></el-input>
            </div>
            <div style="margin-top: 20px">
                <el-button size="mini" type="primary" @click="form.pageNum=1; questionListSelf()">{{ $t('view.搜索') }}</el-button>
                <el-button size="mini" style="margin: 0 10px;" @click="resetting">{{$t('view.重置')}}</el-button>
            </div>

        </div>
        <div style="background: #fff;padding: 20px; margin-bottom: 20px;">
            <div class="title">{{ $t('view.我的问题') }}</div>
            <el-button size="mini" style="margin: 20px 0 10px 0;" type="primary" @click="questionGet('','add')">{{ $t('view.新增') }}</el-button>
            <!-- 表格数据 -->
            <el-table header-row-class-name="tableHeader" :data="tableData" style="width: 1010px" border>
                <el-table-column align="center" type="index" width="60"  show-overflow-tooltip :label="$t('view.序号')"></el-table-column>
                <el-table-column prop="sectionName" show-overflow-tooltip :label="$t('view.招标项目名称')"></el-table-column>
                <el-table-column align="center" prop="companyName" show-overflow-tooltip :label="$t('view.单位名称')"></el-table-column>
                <el-table-column align="center" prop="submitTime" show-overflow-tooltip :label="$t('view.提交时间')"></el-table-column>
                <el-table-column align="center" prop="createByName" show-overflow-tooltip :label="$t('view.提交人')"></el-table-column>
                <el-table-column align="center" prop="createPhonenumber" show-overflow-tooltip :label="$t('view.提交人联系电话')"></el-table-column>
                <el-table-column align="center" prop="date" show-overflow-tooltip :label="$t('view.状态')">
                    <template slot-scope="scope">
                        {{getStatus('statusList',scope.row.status)}}
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="date" :width="locale=='zh'?150:locale=='lo'? 200:180" show-overflow-tooltip :label="$t('view.操作')">
                    <template slot-scope="scope">
                        <span class="clickText" @click="questionGet(scope.row.id,'det')">{{ $t('view.详情') }}</span>
                        <span class="clickText" @click="submitTo(scope.row)" style="margin: 0 10px" v-if="scope.row.status==1">{{ $t('view.提交') }}</span>
                        <span class="clickText" @click="questionDel(scope.row.id)" v-if="scope.row.status==1">{{ $t('view.删除') }}</span>
                    </template>
                </el-table-column>
            </el-table>
                <el-pagination style="text-align: center;width: 100%;margin-top: 20px;" layout="prev, pager, next"  :total="total" @current-change="handleCurrentChange"></el-pagination>
            <!-- </div> -->
        </div>

    </div>
  </template>
    
<script>
import {questionListSelf,questionPut ,questionPost,questionGet,questionDel} from '@/api/PersonalCenter'
  export default {
    data(){
        return{
            tableData:[],
            total:0,
            options:[],
            dialogForm:{
                companyName:'',sectionId:'', problemDescription:'', createByName:'', createPhonenumber:''
            }, //弹窗信息
            dialogVisible:false,//弹窗
            projectList:[],//项目列表
            loading:false,
            dialogRules:{problemDescription: [{ required: true, trigger: 'changes', message: this.$t('view.请输入')}]},
            statusList:[{ dictValue:'1', dictLabel:this.$t('view.草稿')},{ dictValue:'2', dictLabel:this.$t('view.提交未回复')},{ dictValue:'3', dictLabel:this.$t('view.已回复')}],
            value:'',
            TimeList:[],//时间
            locale: localStorage.getItem('locale')||'zh',
            form:{
                pageNum:1,
                createByName:'',
                companyName:'',
                sectionName:'',
                status:'',
                pageSize:10
            }
        }
    },
    created(){
        this.questionListSelf()
    },
    methods:{
         // 提交
         submitTo(data){
            this.$confirm(this.$t('view.是否提交该信息?'), this.$t('view.提示'), {
                confirmButtonText: this.$t('view.确定'),
                cancelButtonText: this.$t('view.取消'),
                type: 'warning'
            }).then(() => {
                data.status=2
                data.submitrime=Date.now();
                questionPut(data).then(res=>{
                    this.$message.success('操作成功')
                    this.handleClose()
                    this.questionListSelf()
                })  
            })   

        },
        // 删除
        questionDel(id){
            this.$confirm(this.$t('view.是否删除该信息?'), this.$t('view.提示'), {
                confirmButtonText:this.$t('view.确定'),
                cancelButtonText: this.$t('view.取消'),
                type: 'warning'
            }).then(() => {
                questionDel(id).then(res=>{
                    this.$message.success(this.$t('view.操作成功'))
                    this.handleClose()
                    this.questionListSelf()
                })  
            })   
        },

        // 详情
        questionGet(id,type){
            this.$router.push({
                path:'MyQuestionDet',
                query:{id:id,type:type}
            })
        },

        // 确认
        confirm(status){
            this.$refs.dialogForm.validate(valid => {
                if (valid) {
                    this.dialogForm.sectionName  =this.projectList.filter(item=>item.sectionId ==this.dialogForm.sectionId)[0].sectionName
                    let api =this.dialogForm.id? questionPut : questionPost
                    this.dialogForm.status=status
                    if(status==2)
                    this.dialogForm.submitrime=Date.now();
                    api(this.dialogForm).then(res=>{
                        this.$message.success(this.$t('view.操作成功'))
                        this.handleClose()
                        this.questionListSelf()
                    })
                }
            })
        },
        // 新增
        add(){
            this.dialogForm={
                companyName:'',sectionId:'', problemDescription:'', createByName:'', createPhonenumber:''
            }
            
            this.questionGetAuthSection()
            this.dialogVisible=true
        },
        handleClose(){
            this.dialogVisible=false
            this.resetForm('dialogForm');
        },  
        // 重置
        resetting(){
            this.form={
                pageNum:1,
                createByName:'',
                companyName:'',
                sectionName:'',
                status:'',
                pageSize:10
            }
            this.TimeList=[]
            this.questionListSelf()
        },
        handleCurrentChange(e){
            this.form.pageNum=e
            this.questionListSelf()
        },
        questionListSelf(){
            let beginSubmitTime='params["beginSubmitTime"]'
            let endSubmitTime='params["endSubmitTime"]'
            this.form[beginSubmitTime] =(this.TimeList&&this.TimeList.length)?this.TimeList[0]:''
            this.form[endSubmitTime]=(this.TimeList&&this.TimeList.length)?this.TimeList[1]+" 23:59:59":''
            questionListSelf(this.form).then(res=>{
                this.total=res.total
                this.tableData=res.rows
            })
        },  
    }
};
</script>
<style lang="scss" scoped>  
    .whiteBox span{
        color: #333333;
        font-size: 14px;
    }
    .whiteBox div{width:  30%;}
    .title{
        font-size: 16px;
        font-weight: 600;
        color: #333333;
    }
</style>
   